import { gql } from '@yi/core';

import { graphql, useStaticQuery } from 'gatsby';

export const SpecialOffersCoursesQueryEs = () => {
  const data = useStaticQuery<gql.typesSsr.Query_SpecialOffers_Courses_Es>(graphql`
    query Query_SpecialOffers_Courses_Es {
      yi {
        SiteVars(language: SPANISH) {
          featured_ecourses {
            ...Fragment_CourseCard
          }
        }
      }
    }
  `);
  return { data: data.yi };
};
